import { useCallback, useEffect, useState } from 'react'
import { NOTIFICATION_SOUND, read, store } from '@web/modules/core'
import NotificationSound from '@web/assets/notification-sound.wav'

export const useNotificationSound = () => {
  const [soundEnabled, setSoundEnabled] = useState(read(NOTIFICATION_SOUND) === 'enabled')

  useEffect(() => {
    if (!read(NOTIFICATION_SOUND)) {
      store(NOTIFICATION_SOUND, 'enabled')
      setSoundEnabled(true)
    }
  }, [])

  const changeSound = () => {
    if (soundEnabled) {
      store(NOTIFICATION_SOUND, 'disabled')
      setSoundEnabled(false)
    } else {
      store(NOTIFICATION_SOUND, 'enabled')
      setSoundEnabled(true)
      playSound()
    }
  }

  const playSound = useCallback(() => {
    if (read(NOTIFICATION_SOUND) === 'enabled') {
      const audio = new Audio(NotificationSound)
      audio.addEventListener('canplaythrough', () => {
        audio.play()
      })
    }
  }, [])

  const changeSoundStorage = (storage: StorageEvent) => {
    if (storage.key === NOTIFICATION_SOUND) {
      setSoundEnabled(storage.newValue === 'enabled')
    }
  }

  return {
    soundEnabled,
    changeSound,
    changeSoundStorage,
    playSound
  }
}
